import React, { useCallback } from 'react';
import { ChevronRight } from '@mui/icons-material';
import styles from './news-page.module.css';
import { SecondaryBanners } from '../secondary-banners/secondary-banners';
import { Pagination } from '../../components';
import { fetchPosts, PostItem, FetchPostsResult } from '../../apis/news';
import {
  Breadcrumb,
  BreadcrumbItem,
} from '../../components/breadcrumb/breadcrumb';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../routes';

export const NewsPage: React.FC = () => {
  const [newsData, setNewsData] = React.useState<PostItem[]>([]);
  const [totalCount, setTotalCount] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const navigate = useHistory();
  const itemsPerPage = 11;

  React.useEffect(() => {
    fetchPosts(page - 1, itemsPerPage).then(
      ({ items, total }: FetchPostsResult) => {
        setNewsData(items);
        setTotalCount(total);
      }
    );
  }, [page]);

  const totalPages = Math.max(1, Math.ceil(totalCount / itemsPerPage));

  const breadcrumbs: BreadcrumbItem[] = [
    { name: 'Notícias', path: ROUTES.NEWS_PAGE },
  ];

  const handleChange = (_: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const goToNewPage = useCallback(
    (id: string) => {
      navigate.push(ROUTES.DYNAMIC_NEWS_PAGE.replace(':newsType', id));
    },
    [navigate]
  );

  const mainNews = newsData[0];
  const sideNews = newsData.slice(1, 4);
  const middleNews = newsData.slice(4, 7);
  const bottomMainNews = newsData[7];
  const bottomSideNews = newsData.slice(8, 11);

  return (
    <section className={styles.newsPage}>
      <div className={styles.headerContainer}>
        <div className={styles.breadcrumbs}>
          <div className="xvia-catalog__breadcrumb_header">
            <Breadcrumb items={breadcrumbs} aria-label="breadcrumb" />
          </div>
        </div>
        <div className={styles.headerTitle}>Notícias</div>
      </div>

      {mainNews && (
        <div className={styles.topGridContainer}>
          <div
            onClick={() => goToNewPage(mainNews.id)}
            className={styles.mainNews}
          >
            {mainNews.image && (
              <img src={mainNews.image} alt={mainNews.title} />
            )}
            <div className={styles.overlay}>
              <div className={styles.mainNewsTheme}>
                {`${mainNews.theme} | Destaque`}
              </div>
              <div className={styles.mainNewsTitle}>{mainNews.title}</div>
            </div>
          </div>

          <div className={styles.sideNews}>
            {sideNews.map((news) => (
              <div
                onClick={() => goToNewPage(news.id)}
                key={news.id}
                className={styles.sideNewsItem}
              >
                {news.image && <img src={news.image} alt={news.title} />}
                <div className={styles.sideNewsOverlay}>
                  <div className={styles.newsTheme}>
                    <span>{news.theme}</span>
                    <span> há {news.time}</span>
                  </div>
                  <div className={styles.newsTitle}>{news.title}</div>
                  <div className={styles.goToNews}>
                    Acessar completa <ChevronRight />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className={styles.middleRow}>
        {middleNews.map((news) => (
          <div
            onClick={() => goToNewPage(news.id)}
            key={news.id}
            className={styles.middleNewsItem}
          >
            {news.image && <img src={news.image} alt={news.title} />}
            <div className={styles.middleOverlay}>
              <div className={styles.newsTheme}>
                <span>{news.theme}</span>
                <span> há {news.time}</span>
              </div>
              <div className={styles.newsTitle}>{news.title}</div>
              <div className={styles.goToNews}>
                Acessar completa <ChevronRight />
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className={styles.secondaryBanners}>
        <SecondaryBanners disableBackground />
      </div>

      {bottomMainNews && (
        <div className={styles.bottomGridContainer}>
          <div
            className={styles.mainNews}
            onClick={() => goToNewPage(bottomMainNews.id)}
          >
            {bottomMainNews.image && (
              <img src={bottomMainNews.image} alt={bottomMainNews.title} />
            )}
            <div className={styles.overlay}>
              <div className={styles.mainNewsTheme}>
                {`${bottomMainNews.theme} | Destaque`}
              </div>
              <div className={styles.mainNewsTitle}>{bottomMainNews.title}</div>
            </div>
          </div>

          <div className={styles.sideNews}>
            {bottomSideNews.map((news) => (
              <div
                onClick={() => goToNewPage(news.id)}
                key={news.id}
                className={styles.sideNewsItem}
              >
                {news.image && <img src={news.image} alt={news.title} />}
                <div className={styles.sideNewsOverlay}>
                  <div className={styles.newsTheme}>
                    <span>{news.theme}</span>
                    <span> há {news.time}</span>
                  </div>
                  <div className={styles.newsTitle}>{news.title}</div>
                  <div className={styles.goToNews}>
                    Acessar completa <ChevronRight />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className={styles.paginationContainer}>
        <Pagination count={totalPages} onChange={handleChange} page={page} />
      </div>
    </section>
  );
};
